export default "__VITE_ASSET__BTgxShC$__"